import script from "./payroll-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./payroll-modal.vue?vue&type=script&setup=true&lang=js"

import "./payroll-modal.vue?vue&type=style&index=0&id=c95a7cba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c95a7cba"]])

export default __exports__